export default "__VITE_ASSET__BtHt__IY__"